var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseCardContainer',{attrs:{"title":"Clôture"},scopedSlots:_vm._u([{key:"footer",fn:function({}){return undefined}}])},[_c('ProspectClotureForm',{attrs:{"data":_vm.prospect},on:{"onSubmit":_vm.onSubmit,"onCancel":_vm.onCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }